
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_18005_4843)"}},[_c('path',{attrs:{"d":"M13.566 8.303c.072-.41.12-.844.12-1.279C13.686 3.38 10.717.41 7.048.41 6.614.41 6.18.46 5.77.531A3.803 3.803 0 003.838 0 3.832 3.832 0 000 3.838c0 .7.193 1.376.531 1.931-.072.41-.12.845-.12 1.28a6.634 6.634 0 006.637 6.637c.435 0 .87-.048 1.28-.12.555.337 1.23.434 1.93.434 2.1 0 3.742-1.641 3.742-3.765 0-.7-.12-1.352-.434-1.932z","fill":"#00B5EB"}}),_c('path',{attrs:{"d":"M7.169 11.61c-2.366 0-3.548-.893-3.91-2.003-.362-1.11.434-1.424.675-1.448.242-.025.773.048.942.507.169.482.676 1.424 1.81 1.544 1.135.121 1.883-.41 2.1-.941.217-.555-.193-1.303-1.93-1.545-1.739-.241-3.573-1.014-3.573-2.776 0-1.762 2.027-2.462 3.934-2.462s2.873 1.086 3.09 1.497c.265.53.169 1.4-.459 1.545-.651.169-.99-.194-1.472-1.087-.483-.917-2.245-.675-2.824-.169-.58.531-.435 1.28 2.027 1.738 2.438.483 3.356 1.352 3.356 2.752-.025 1.376-1.4 2.848-3.766 2.848z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_18005_4843"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    